<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card">
      <div class="card-body">
        <ValidationObserver v-slot="{ invalid, handleSubmit }">
          <form @submit.prevent="handleSubmit(onSubmit)" ref="formContainer">
            <div class="row" ref="formContainer">
              <div class="content-lis col-md-6">
                <div class="cs-title-box">
                  <div class="cs-title py-2" style="padding: 10px">
                    <span class="fw-normal font-size-13"
                      >THÔNG TIN TIN ĐĂNG</span
                    >
                  </div>
                </div>
              </div>

              <div class="mt-2 col-md-6">
                <div class="d-flex justify-content-end align-items-center">
                  <div class="form-check form-switch me-3 mb-0">
                    <label
                      class="text-left mb-0 me-2"
                      for="flexSwitchCheckChecked"
                      >Xuất bản</label
                    >
                    <input
                      v-model="modelContent.isPublish"
                      class="form-check-input"
                      type="checkbox"
                      id="flexSwitchCheckChecked"
                    />
                  </div>

                  <div>
                    <b-button
                      type="submit"
                      variant="success"
                      class="px-3 btn-luu"
                      :disabled="invalid || isLoading"
                    >
                      {{ isLoading ? "Đang lưu..." : "Đăng tin tức" }}
                    </b-button>
                  </div>
                </div>
              </div>
              <div class="col-12 mb-3">
                <ValidationProvider
                  :rules="tinTucValidator.rules.name"
                  name="Tiêu đề"
                  v-slot="{ errors }"
                >
                  <label class="text-left mb-0"
                    >Tiêu đề
                    <span class="text-left" style="color: red"
                      >&nbsp;(Tối đa {{ maxTitleLength }} ký tự)*</span
                    ></label
                  ><span
                    class="fw-bold ms-2 text-muted"
                    style="font-size: 0.85rem"
                  >
                    ({{ titleCharacterCount }}/{{ maxTitleLength }} ký tự)
                  </span>
                  <input
                    v-model="modelContent.name"
                    class="form-control"
                    :class="{ 'is-invalid': errors[0] }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </div>
              <div class="col-4 mb-3">
                <label class="text-left mb-0">Ngày xuất bản</label>
                <Datepicker
                  v-model="modelContent.publicationDate"
                  :enable-time-picker="false"
                  :format="format"
                  :text-input="true"
                  placeholder="__/__/____"
                  :lang="langCustom"
                  :min-date="today"
                  :day-names="customDayNames"
                  auto-apply
                />
              </div>
              <div class="col-4 mb-3">
                <label class="text-left mb-0"
                  >Loại tin tức<span style="color: red">&nbsp;*</span></label
                >

                <ValidationProvider
                  :rules="tinTucValidator.rules.menu"
                  name="Loại tin tức"
                  v-slot="{ errors }"
                >
                  <VueMultiselect
                    class="multiselect"
                    v-model="modelContent.menu"
                    :options="listCommon"
                    label="name"
                    track-by="code"
                    placeholder="Chọn loại tin tức"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </div>
              <div class="col-4 mb-3">
                <ValidationProvider
                  :rules="tinTucValidator.rules.nameAuthor"
                  name="Tên tác giả"
                  v-slot="{ errors }"
                >
                  <label class="text-left mb-0"
                    >Tác giả
                    <span class="text-left" style="color: red"
                      >&nbsp;*</span
                    ></label
                  >
                  <input
                    v-model="modelContent.nameAuthor"
                    class="form-control"
                    :class="{ 'is-invalid': errors[0] }"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </div>
              <div class="col-4 mb-3">
                <div class="mb-2">
                  <ValidationProvider
                    ref="providerFileImage"
                    name="Ảnh đại diện"
                    :rules="tinTucValidator.rules.fileImage"
                    v-slot="{ errors }"
                  >
                    <label class="text-left mb-0">
                      Ảnh đại diện (600px * 400px)<span style="color: red"
                        >*</span
                      >
                    </label>

                    <input
                      id="formFileSm"
                      name="file-input"
                      ref="fileInput"
                      type="file"
                      class="form-control"
                      @change="upload($event)"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>

                    <div
                      v-if="modelContent.fileImage?.fileId"
                      class="d-flex align-items-end mt-2"
                    >
                      <!-- Ảnh Đại diện -->
                      <ZoomableImage
                        :currentImageSrc="url + modelContent.fileImage.fileId"
                        :smallImageStyle="{
                          cursor: 'pointer',
                        }"
                      />
                      <!-- Nút Xóa Ảnh (Sử dụng component ButtonCore đã đổi tên) -->
                      <ButtonCore
                        text="Xóa"
                        variantClass="btn-danger-core"
                        iconClass="fas fa-trash-alt"
                        :handleClick="deleteFile"
                        :customStyle="{ height: '40px' }"
                      />
                    </div>
                  </ValidationProvider>
                </div>
              </div>

              <div class="col-4">
                <div class="mb-2">
                  <label class="text-left mb-0">Thứ tự ưu tiên</label>
                  <span style="color: red">&nbsp;*</span>
                  <input
                    v-model="modelContent.sort"
                    id="percent"
                    type="number"
                    class="form-control"
                    placeholder="Nhập thứ tự"
                  />
                </div>
              </div>

              <div class="col-md-12">
                <div class="mb-2">
                  <ValidationProvider
                    :rules="tinTucValidator.rules.describe"
                    name="Mô tả bài viết"
                    v-slot="{ errors }"
                  >
                    <label class="text-left mb-0">Mô tả</label>
                    <span class="text-left" style="color: red"
                      >&nbsp;(Tối đa {{ maxDescribeLength }} ký tự)*</span
                    >
                    <span
                      class="fw-bold ms-2 text-muted"
                      style="font-size: 0.85rem"
                    >
                      ({{ describeCharacterCount }}/{{ maxDescribeLength }} ký
                      tự)
                    </span>
                    <textarea
                      v-model="modelContent.describe"
                      id="percent"
                      type="text"
                      class="form-control mota"
                      placeholder="Nhập mô tả"
                    >
                    </textarea>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </div>
              </div>
              <div class="content-lis col-10">
                <div class="cs-title-box">
                  <div class="cs-title py-2">
                    <span class="fw-normal font-size-13">Nội dung</span>
                  </div>
                </div>
              </div>
              <div>
                <ValidationProvider
                  :rules="tinTucValidator.rules.content"
                  name="Nội dung bài viết"
                  v-slot="{ errors }"
                >
                  <label class="text-left mb-0"
                    >Nội dung bài viết <span class="text-danger">*</span></label
                  >
                  <ckeditor-nuxt
                    v-model="modelContent.content"
                    :config="editorConfig"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";

import { VMoney } from "v-money";
import { pagingModel } from "@/models/core/pagingModel";
import Treeselect from "@riophae/vue-treeselect";
import { menuModel } from "@/models/core/menuModel";
import vue2Dropzone from "vue2-dropzone";
import { notifyModel } from "@/models/core/notifyModel";
import axios from "axios";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { itemTreeModel } from "@/models/core/itemTreeModel";
import VueMultiselect from "vue-multiselect";
import Datepicker from "vue2-datepicker";
import { getCurrentDay } from "@/utils/time/dateUtils";
import {
  LOCALE,
  CUSTOM_DAY_NAMES,
  DEFAULT_DATE_FORMAT,
  LANG_CUSTOM,
  EDITOR_CONFIG,
} from "@/constans";

import { ValidationObserver, ValidationProvider } from "vee-validate";
import { tinTucValidator } from "@/models/profession/tinTuc/tinTucValidator";
import { tinTucModel } from "@/models/profession/tinTuc/tinTucModel";
import { ButtonCore, ZoomableImage } from "@/components/widgets";

export default {
  page: {
    title: "Tạo tin tức",
    meta: [{ name: "description", content: appConfig.description }],
  },
  // eslint-disable-next-line vue/no-unused-components
  components: {
    Layout,
    PageHeader,
    Datepicker,
    ValidationObserver,
    ValidationProvider,
    VueMultiselect,
    ButtonCore,
    ZoomableImage,

    "ckeditor-nuxt": () => {
      return import("@blowstack/ckeditor-nuxt");
    },
    //ckeditor: CKEditor.component
  },
  directives: { money: VMoney },
  data() {
    return {
      data: [],
      title: "Tạo tin tức",
      items: [
        {
          text: "TẠO TIN TỨC",
          active: true,
        },
      ],

      maxTitleLength: 256, // Định nghĩa giới hạn
      maxDescribeLength: 500, // Định nghĩa giới hạn

      errors: {}, // Object to hold validation errors

      customDayNames: CUSTOM_DAY_NAMES,
      langCustom: LANG_CUSTOM,
      format: DEFAULT_DATE_FORMAT,

      tinTucValidator,

      isLoading: false,

      currentPage: 1,
      pageOptions: [5, 10, 25, 50, 100],
      sortBy: "age",
      filter: null,
      sortDesc: false,
      isShow: false,
      filterOn: [],
      numberOfElement: 1,
      totalRows: 1,
      perPage: 10,
      stt: 1,
      submitted: false,
      modelContent: tinTucModel.baseJson(),
      itemTree: itemTreeModel.baseJson(),
      pagination: pagingModel.baseJson(),
      listCommon: [],
      listParent: [],
      //editor: ClassicEditor,
      editorConfig: {
        toolbar: {
          items: [
            "heading",
            "|",
            "style",
            "bold",
            "italic",
            "link",
            "bulletedList",
            "numberedList",
            "|",
            "outdent",
            "indent",
            "|",
            "imageUpload",
            "blockQuote",
            "insertTable",
            "mediaEmbed",
            "codeBlock",
            "alignment",
            "ckbox",
            "fontColor",
            "fontBackgroundColor",
            "fontFamily",
            "fontSize",
            "formatPainter",
            "highlight",
            "htmlEmbed",
            "tableOfContents",
            "undo",
            "redo",
          ],
          shouldNotGroupWhenFull: false,
        },
        removePlugins: ["Title", "ImageCaption"],
        simpleUpload: {
          uploadUrl: process.env.VUE_APP_API_URL + "filesminio/uploadCK",
          headers: {
            Authorization: "optional_token",
          },
        },
      },
      url: `${process.env.VUE_APP_API_URL}filesminio/view/`,
      image: "",
      file: "",
      listMenu: [],
      itemsBaiViet: [
        {
          name: null,
          file: null,
        },
      ],

      showImageModal: false,
      currentImageSrc: "",
      targetIndex: 0,
      // today: getCurrentDay(),
    };
  },
  computed: {
    today() {
      const date = new Date();
      date.setHours(23, 59, 59, 999);
      return date;
    },

    // Tính toán số ký tự cho Tiêu đề
    titleCharacterCount() {
      return this.modelContent.name ? this.modelContent.name.length : 0;
    },

    // Tính toán số ký tự cho Mô tả
    describeCharacterCount() {
      return this.modelContent.describe ? this.modelContent.describe.length : 0;
    },
  },
  // Vuelidate validation

  created() {
    this.getDanhMucTinTuc();
  },
  methods: {
    onClickFile(index) {
      this.targetIndex = index;
    },

    getColorWithExtFile(ext) {
      if (ext == ".png" || ext == ".jpg" || ext == ".jpeg")
        return "text-danger";
    },

    getIconWithExtFile(ext) {
      if (ext == ".png" || ext == ".jpg" || ext == ".jpeg")
        return "mdi mdi-file-image-outline";
    },
    deleteFile() {
      if (this.modelContent != null && this.modelContent.fileImage != null) {
        axios
          .post(
            `${process.env.VUE_APP_API_URL}filesminio/delete/${this.modelContent.fileImage.fileId}`
          )
          .then((res) => {
            const response = res.data;
            this.modelContent.fileImage = null;
            if (this.$refs.fileInput) {
              this.$refs.fileInput.value = "";
            }
            console.log("Res file nè: ,", response);
            console.log("log model file remove", this.modelContent);
            this.$store.dispatch("snackBarStore/addNotify", {
              data: {
                code: response.code,
                message: response.message,
              },
            });
          })
          .catch((error) => {
            // Handle error here
            this.$store.dispatch("snackBarStore/addNotify", {
              data: {
                code: -1,
                message: "Lỗi khi xoá ảnh",
              },
            });
          });
      } else {
        this.$store.dispatch("snackBarStore/addNotify", {
          data: {
            code: -1,
            message: "Chưa có file ảnh",
          },
        });
      }
    },
    onAccept(file) {
      this.image = file.name;
      this.file = file;
    },
    normalizer(node) {
      if (node.children == null || node.children == "null") {
        delete node.children;
      }
    },
    async getDanhMucTinTuc() {
      await this.$store
        .dispatch("common/commonStore/getAll", "DM_TINTUC")
        .then((res) => {
          this.listCommon = res.data;
        });
    },

    async onSubmitTest(e) {
      const payload = tinTucModel.toJson(this.modelContent);

      console.info("Log payload:", payload);

      // payload.menu = {
      //   _id: "string",
      //   name: "string",
      //   code: "code",
      // };
      payload.menu = {
        _id: this.modelContent.menu._id,
        name: this.modelContent.menu.name,
        code: this.modelContent.menu.code,
      };

      console.log("Log submit nè", payload);
    },

    async onSubmit(e) {
      this.submitted = true;

      try {
        if (!this.modelContent.fileImage) {
          this.$store.dispatch("snackBarStore/addNotify", {
            data: {
              code: "WARNING",
              message: "Vui lòng chọn ảnh đại diện",
            },
          });
          return;
        }

        // → Nếu tới đây = form hợp lệ
        this.isLoading = true;
        const payload = tinTucModel.toJson(this.modelContent);

        console.info("Log payload:", payload);

        payload.menu = {
          _id: this.modelContent.menu._id,
          name: this.modelContent.menu.name,
          code: this.modelContent.menu.code,
        };

        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        });
        console.log("Log submit nè", payload);

        await this.$store
          .dispatch(
            "profession/tinTuc/tinTucStore/create",
            tinTucModel.toJson(this.modelContent)
          )
          .then((res) => {
            if (res.code === 0) {
              this.showModal = false;
              this.modelContent = tinTucModel.baseJson();
              this.modelContent.content = "";
              this.$router.push("/danh-sach-tin-tuc");
            }
            this.$store.dispatch("snackBarStore/addNotify", {
              data: {
                code: res.code,
                message: res.message,
              },
            });
          });
        loader.hide();
        this.submitted = false;
      } catch (err) {
        console.error("Submission error:", err);
        // Yup lỗi → gom tất cả lỗi vào object
        if (err.inner) {
          const errors = {};
          err.inner.forEach((e) => {
            errors[e.path] = e.message;
          });
          this.errors = errors;
        } else {
          this.$toast.error(err.message || "Có lỗi xảy ra");
        }
      } finally {
        this.isLoading = false;
      }
    },
    // uploadFile(files, response) {
    //   let fileSuccess = response.data;
    //   console.log("log suscess", response.data);
    //   if (response.code == 0) {
    //     this.modelContent.file.push({
    //       fileId: fileSuccess.fileId,
    //       fileName: fileSuccess.fileName,
    //       ext: fileSuccess.ext,
    //       path: fileSuccess.path,
    //     });
    //   }
    //   console.log("log model file", this.modelContent.files);
    // },
    clearFile() {
      console.log("LOG CLEAR ");
    },
    // removeThisFile(files, error, xhr, index) {
    //   let fileCongViec = JSON.parse(files.xhr.response);
    //   if (fileCongViec.data && fileCongViec.data.fileId) {
    //     let idFile = fileCongViec.data.fileId;
    //     let resultData = this.itemsBaiViet[index].file.filter((x) => {
    //       return x.fileId != idFile;
    //     });
    //     this.itemsBaiViet[index].file = resultData;
    //     //  console.log('log model file remove', this.modelContent.files)
    //   }
    // },
    sendingEvent(files, xhr, formData) {
      console.log("log file", files);
      formData.append("files", files);
    },
    formatDate(dateString) {
      // Chuyển đổi định dạng ngày từ DD/MM/YYYY sang YYYY-MM-dd
      const [day, month, year] = dateString.split("/");
      const formattedDate = `${year}-${month}-${day}`;
      return formattedDate;
    },
    async upload(event) {
      // Xóa file cũ
      if (this.modelContent?.fileImage?.fileId) {
        try {
          await axios.post(
            `${process.env.VUE_APP_API_URL}filesminio/delete/${this.modelContent.fileImage.fileId}`
          );
          this.modelContent.fileImage = null;
        } catch (e) {
          console.error("Upload error:", e);
        }
      }

      // Lấy file mới
      const file = event.target?.files?.[0];
      if (!file) return;

      const formData = new FormData();
      formData.append("files", file);

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}filesminio/Upload`,
          formData
        );

        if (response.data.code === 0) {
          let result = response.data.data;

          this.modelContent.fileImage = {
            fileId: result.fileId,
            fileName: result.fileName,
            ext: result.ext,
            path: result.path,
          };

          console.log("validate value = ", this.modelContent.fileImage);

          // ⭐ Bắt ValidationProvider validate lại
          this.$refs.providerFileImage.validate();
        }
      } catch (e) {
        console.error("Upload error:", e);
      }
    },
    addItem: function () {
      this.itemsBaiViet.push({
        name: null,
        file: null,
      });
      this.targetIndex++;
    },
    removeItem: function () {
      this.itemsBaiViet.pop({
        name: null,
        file: null,
      });
      this.targetIndex--;
    },
  },

  watch: {
    modelContent: {
      deep: true,
      handler(val) {
        console.log("Model changed:", val);
      },
    },
  },
};
</script>

<style>
.hidden-sortable:after,
.hidden-sortable:before {
  display: none !important;
}
.vue-treeselect__menu {
  max-height: 165px !important;
}
.btn-luu {
  background-color: rgb(181, 0, 39);
  border: none;
}
.btn-luu:hover {
  background-color: rgb(170, 23, 54);
}

.mota {
  height: 100px;
}

.page-content {
  min-height: 800px;
}
</style>
